import {clamp} from '@/util/bounds.js'


export const ZOOM_LEVELS = [
    0.005,
    0.01,
    0.025,
    0.05,
    0.1,
    0.125,
    0.25,
    0.33,
    0.5,
    0.75,
    1,
    2,
    3,
    4,
    5,
    8,
    16
];
export const MIN_ZOOM = ZOOM_LEVELS[0];
export const MAX_ZOOM = ZOOM_LEVELS[ZOOM_LEVELS.length-1];

export function getZoomIndex(z) {
    // simple
    const exactIndex = ZOOM_LEVELS.indexOf(z);
    if (exactIndex !== -1) {
        return exactIndex;
    }

    // search
    let closestZ = 0; // = ZOOM_LEVELS.length-1;
    for (let i=0, len=ZOOM_LEVELS.length; i<len; i++) {
        if (z > ZOOM_LEVELS[i]) {
            closestZ = i;
        }
    }
    // console.log(closestZ);

    return closestZ;
}

export function getZoomIn(state, power = 1) {

    if (power > 1) {
        return getZoomIn(getZoomIn(state, power - 1));
    }

    let zoomIndex = getZoomIndex(state) + 1;
    // zoomIndex = ZOOM_LEVELS[zoomIndex] == state ? zoomIndex+1 : zoomIndex+1;
    zoomIndex = clamp(zoomIndex, 0, ZOOM_LEVELS.length-1);
    const z = ZOOM_LEVELS[zoomIndex];

    return clamp(z, MIN_ZOOM, MAX_ZOOM);
}

export function getZoomOut(state, power = 1) {
    if (power > 1) {
        return getZoomOut(getZoomOut(state, power - 1));
    }

    let zoomIndex = getZoomIndex(state);
    if (ZOOM_LEVELS[zoomIndex] == state) {
        zoomIndex--;
    }
    zoomIndex = clamp(zoomIndex, 0, ZOOM_LEVELS.length-1);
    const z = ZOOM_LEVELS[zoomIndex];

    return clamp(z, MIN_ZOOM, MAX_ZOOM);
}


export function getPanForZoom(offsetX, offsetY, from_z, to_z) {
    /*
        algebreaic refactor from original:
        const panX = this.props.panX + (e.offsetX - this.props.width / 2) / newZ - (e.offsetX - this.props.width / 2) / z;

        new pan is old pan plus 
        distance from mouse (?) to center under new zoom,
        minus distance from mouse to center under old zoom.
    */

    /*
        to_z = from_z * dz
        dz = to_z / from_z
    */
    //console.log('zoomAroundPointer');
    
    // const panX = this.props.panX + ((gesturePosition.pageX - this.props.width/2)  * (1 - (to_z/from_z))) / to_z;
    // const panY = this.props.panY + ((gesturePosition.pageY - this.props.height/2) * (1 - (to_z/from_z))) / to_z;
    
    //console.trace('PAN x, y', this.props.panX, gesturePosition.pageX, to_z, from_z);
    return {
        dx: (offsetX * (1 - (to_z/from_z))) / to_z,
        dy: (offsetY * (1 - (to_z/from_z))) / to_z
    }
}


// zoom is linear [-INF..0..INF]
// scale is logarithmic [0..1..INF]
// Many things need to be done in linear space, or they don't feel right
// so it's convenient to be able to convert back and forth.
export function scaleToZoom(scale) {
    // console.log(scale)
    return Math.log2(scale)
}

export function zoomToScale(zoom) {
    return clamp(Math.pow(2, zoom), MIN_ZOOM, MAX_ZOOM);
}

